export default function strokedTransform(input) {
  return input
    .replace(/a/gi, "Δ")
    .replace(/b/gi, "β")
    .replace(/c/gi, "Ć")
    .replace(/d/gi, "Đ")
    .replace(/e/gi, "€")
    .replace(/f/gi, "₣")
    .replace(/g/gi, "Ǥ")
    .replace(/h/gi, "Ħ")
    .replace(/i/gi, "Ξ")
    .replace(/j/gi, "Ĵ")
    .replace(/k/gi, "Ҝ")
    .replace(/l/gi, "Ł")
    .replace(/m/gi, "Μ")
    .replace(/n/gi, "Ň")
    .replace(/o/gi, "Ø")
    .replace(/p/gi, "Р")
    .replace(/q/gi, "Ω")
    .replace(/r/gi, "Ř")
    .replace(/s/gi, "Ş")
    .replace(/t/gi, "Ŧ")
    .replace(/u/gi, "Ữ")
    .replace(/v/gi, "V")
    .replace(/x/gi, "Ж")
    .replace(/w/gi, "Ŵ")
    .replace(/y/gi, "¥")
    .replace(/z/gi, "Ž")
    .replace(/ /gi, "ㅤ");
}
